<mat-card style="border-color: #5775a8;">
  <mat-card-header  cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full">
      <div class="flex flex-col w-full">
        <h4 style="color:white;">Post Remediation Plan Visit</h4>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">
      <div class="flex flex-col">
        <mat-form-field class="container">
          <mat-label>Post Remediation Visit Date</mat-label>
          <input matInput [matDatepicker]="postRemediationDate" formControlName="postRemediationDate">
          <mat-datepicker-toggle matSuffix [for]="postRemediationDate"></mat-datepicker-toggle>
          <mat-datepicker #postRemediationDate></mat-datepicker>
          <mat-error *ngIf="form.get('postRemediationDate').invalid">
            Invalid Date.
          </mat-error>
        </mat-form-field>

        <div class="flex flex-col w-full" style="align-items: baseline;">
          <span>Was the Post Remediation site visit conducted?</span>
          <mat-radio-group formControlName="postRemediationConducted">
            <mat-radio-button color="primary" class="p-x-8" value='1'
              (change)="siteVisitUpdate('1')">Yes</mat-radio-button>
            <mat-radio-button color="primary" class="p-l-8" value='0'
              (change)="siteVisitUpdate('0')">No</mat-radio-button>
          </mat-radio-group>
        </div>
        
        <div class="flex flex-col">
          <span *ngIf="remediationFlag">Post Remediation Plan Visit Result</span>
          <span *ngIf="!remediationFlag">Reason not conducted {{siteVisit.postRemediationResult}}</span>
          <mat-radio-group formControlName="postRemediationResult" (change)="radioSelected($event.value)">
            <mat-radio-button *ngIf="remediationFlag" color="primary" class="p-x-8" value='1'>
              No Violations.
            </mat-radio-button>
            <mat-radio-button *ngIf="remediationFlag" color="primary" class="p-l-8" value='2'>
              Violations observed (forward this complaint to OHA).
            </mat-radio-button>
            <mat-radio-button *ngIf="!remediationFlag" color="primary" class="p-l-8" value='1'>
              Post Remediation visit denied (forward to OHA)
            </mat-radio-button>
            <mat-radio-button *ngIf="!remediationFlag" color="primary" class="p-l-8" value='2'>
              Other (explain in comments)
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <span *ngIf="warningFlag" class="text-danger">
          <br /> 
          <span style="color:red;"> 
            You have chosen a Post Remediation Visit Result that requires you to forward this Complaint to OHA
          </span>           
        </span>

        <div class="flex clex-col w-full">
          <mat-form-field class="w-full">
            <mat-label>Site Visit Notes</mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="comments" cdkAutosizeMinRows="6"></textarea>
          </mat-form-field>
        </div>

        <div class="flex flex-row w-full">
					<div style="padding-right: 20px;">
						<button mat-raised-button (click)="save()" style="padding-right: 20px; background: #7ABDF3;">
							Save
						</button>
					</div>

					<div style="padding-right: 20px;">
						<button mat-raised-button (click)="return()" style="padding-right: 20px;">
							Return
						</button>
					</div>
				</div>

      </div>

    </form>

  </mat-card-content>

</mat-card>


